// 页面初始化
export const INIT = 'INIT' // 登录
export const SET_NOW_TIME = 'SET_NOW_TIME' // 设置当前时间戳

export const SET_PAGE_LOADING = 'SET_PAGE_LOADING' // 设置当前页面是否正在拉取接口

// 用户部分
export const LOGIN = 'LOGIN' // 登录
export const LOGOUT = 'LOGOUT' // 登出

export const CHECK_MOBILE = 'CHECK_MOBILE' // 检测是否为手机，以宽度768px

export const IS_ARTICLE_PAGE = 'IS_ARTICLE_PAGE' // 检测是否在文章详情页

export const SET_LAYOUT_NAV = 'SET_LAYOUT_NAV' // 设置 Layout 导航

export const OFFLINE_MODAL_STATUS = 'OFFLINE_MODAL_STATUS' // 下线提示框的显示状态

export const SET_PHONE_LIST = 'SET_PHONE_LIST' // 设置手机区号列表

export const SET_ACTIVITY_FORM_STATUS = 'SET_ACTIVITY_FORM_STATUS' // 活动报名表单的状态

export const SET_USER_INFO = 'SET_USER_INFO' // 设置用户信息

export const SET_PAGE_ACTION = 'SET_PAGE_ACTION' // 页面加载后  从本地获取跳走前的动作  继续执行

export const SET_LOGIN_DOMAIN = 'SET_LOGIN_DOMAIN'
